import {styled} from "@reside/ui";

export const Baloons = styled((props: any) => (
  <img src="/assets/baloons.svg" alt="Last slide baloons" {...props} />
))`
  width: 140px;
  margin-bottom: 40px;
`;
